import React from 'react';
import styled from '@emotion/styled';
import useCurrentUser from '~/react-hooks/use-current-user';
import colours from '~/utils/colours';

export interface MandateProps {
  className?: string;
}

const Title = styled.strong`
  color: ${colours.darkGrey};
  margin-bottom: 12px;
  display: block;
`;

const Wrapper = styled.div`
  width: 100%;
  padding: 20px;
  background: ${colours.contentMainBg};
  border-radius: 5px;
`;

const Text = styled.p`
  margin-bottom: 0;
`;

const Mandate = ({ className }: MandateProps) => {
  const currentUser = useCurrentUser();

  return (
    <Wrapper className={className}>
      <Title>SCA Mandate</Title>
      <Text>
        By continuing I the user {currentUser.email} authorise Bonjoro to send
        instructions to the financial institution that issued my card to take
        payments from my card account in accordance with the terms of my
        agreement with you.
      </Text>
    </Wrapper>
  );
};

export default Mandate;
